import { Routes, Route } from 'react-router-dom';

import AuthContainer from './containers/auth/Auth.container';
import ProgrammeContainer from './containers/programme/Programme.container';
import SystemNotices from './components/common/system-notices/SystemNotices';
import Spinner from './components/common/spinner/Spinner';

import './stylesheets/app.scss';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/*" element={<AuthContainer />} />
        <Route path="/programmes/*" element={<ProgrammeContainer />} />
      </Routes>
      <SystemNotices />
      <Spinner />
    </div>
  );
}

export default App;
